import { application } from './application'

import ActionController from './controllers/action_controller'
import ActionsOverflowController from './controllers/actions_overflow_controller'
import ActionsPickerController from './controllers/actions_picker_controller'
import AttachmentsController from './controllers/attachments_controller'
import BackToTopController from './controllers/back_to_top_controller'
import BelongsToFieldController from './controllers/fields/belongs_to_field_controller'
import BooleanFilterController from './controllers/boolean_filter_controller'
import BrowserTimezoneController from './controllers/browser_timezone_controller'
import CheckboxListFieldController from './controllers/fields/checkbox_list_field_controller'
import ClearInputController from './controllers/fields/clear_input_controller'
import CodeFieldController from './controllers/fields/code_field_controller'
import AppearanceController from './controllers/appearance_controller'
import AppearancePreviewController from './controllers/appearance_preview_controller'
import ConfirmDialogController from './controllers/confirm_dialog_controller'
import CopyToClipboardController from './controllers/copy_to_clipboard_controller'
import DateFieldController from './controllers/fields/date_field_controller'
import DateTimeFilterController from './controllers/date_time_filter_controller'
import DistributionChartController from './controllers/distribution_chart_controller'
import DropdownController from './controllers/dropdown_menu_controller'
import PopoverMenuController from './controllers/popover_menu_controller'
import SidebarFlyoutController from './controllers/sidebar_flyout_controller'
import EasyMdeController from './controllers/fields/easy_mde_controller'
import FilterController from './controllers/filter_controller'
import FormController from './controllers/form_controller'
import GridCoverEmptyStateController from './controllers/grid_cover_empty_state_controller'
import HeaderMenuController from './controllers/header_menu_controller'
import HiddenInputController from './controllers/hidden_input_controller'
import ImageLightboxController from './controllers/image_lightbox_controller'
import IndexRowNavigatorController from './controllers/index_row_navigator_controller'
import InputAutofocusController from './controllers/input_autofocus_controller'
import ItemSelectAllController from './controllers/item_select_all_controller'
import ItemSelectorController from './controllers/item_selector_controller'
import KeyboardShortcutsSearchController from './controllers/keyboard_shortcuts_search_controller'
import KeyValueController from './controllers/fields/key_value_controller'
import LoadingButtonController from './controllers/loading_button_controller'
import ManualFrameController from './controllers/manual_frame_controller'
import MapDarkModeController from './controllers/map_dark_mode_controller'
import MediaLibraryAttachController from './controllers/media_library_attach_controller'
import MediaLibraryController from './controllers/media_library_controller'
import MenuController from './controllers/menu_controller'
import ModalController from './controllers/modal_controller'
import ModalSizeController from './controllers/modal_size_controller'
import MultipleSelectFilterController from './controllers/multiple_select_filter_controller'
import NestedFormController from './controllers/nested_form_controller'
import PanelRefreshController from './controllers/fields/panel_refresh_controller'
import PerPageController from './controllers/per_page_controller'
import PersistentModalController from './controllers/persistent_modal_controller'
import PreviewController from './controllers/preview_controller'
import ProgressBarFieldController from './controllers/fields/progress_bar_field_controller'
import RecordSelectorController from './controllers/record_selector_controller'
import ReloadBelongsToFieldController from './controllers/fields/reload_belongs_to_field_controller'
import ResizableEditorController from './controllers/fields/resizable_editor_controller'
import ResourceEditController from './controllers/resource_edit_controller'
import ResourceIndexController from './controllers/resource_index_controller'
import ResourceSearchController from './controllers/resource_search_controller'
import ResourceShowController from './controllers/resource_show_controller'
import SelectController from './controllers/select_controller'
import SelectFilterController from './controllers/select_filter_controller'
import SelfDestroyController from './controllers/self_destroy_controller'
import SidebarController from './controllers/sidebar_controller'
import SidebarResizeController from './controllers/sidebar_resize_controller'
import SignOutController from './controllers/sign_out_controller'
import StarsFieldController from './controllers/fields/stars_field_controller'
import TableRowController from './controllers/table_row_controller'
import TabsController from './controllers/tabs_controller'
import TabsOverflowController from './controllers/tabs_overflow_controller'
import TagsFieldController from './controllers/fields/tags_field_controller'
import TextFilterController from './controllers/text_filter_controller'
import ThemeFaviconController from './controllers/theme_favicon_controller'
import TippyController from './controllers/tippy_controller'
import TiptapFieldController from './controllers/fields/tiptap_field_controller'
import ToggleController from './controllers/toggle_controller'
import TrixBodyController from './controllers/trix_body_controller'
import TrixFieldController from './controllers/fields/trix_field_controller'
import UnsavedChangesController from './controllers/unsaved_changes_controller'

application.register('action', ActionController)
application.register('confirm-dialog', ConfirmDialogController)
application.register('actions-overflow', ActionsOverflowController)
application.register('actions-picker', ActionsPickerController)
application.register('attachments', AttachmentsController)
application.register('back-to-top', BackToTopController)
application.register('boolean-filter', BooleanFilterController)
application.register('browser-timezone', BrowserTimezoneController)
application.register('clear-input', ClearInputController)
application.register('appearance', AppearanceController)
application.register('appearance-preview', AppearancePreviewController)
application.register('copy-to-clipboard', CopyToClipboardController)
application.register('date-time-filter', DateTimeFilterController)
application.register('distribution-chart', DistributionChartController)
application.register('filter', FilterController)
application.register('form', FormController)
application.register('grid-cover-empty-state', GridCoverEmptyStateController)
application.register('header-menu', HeaderMenuController)
application.register('hidden-input', HiddenInputController)
application.register('image-lightbox', ImageLightboxController)
application.register('index-row-navigator', IndexRowNavigatorController)
application.register('input-autofocus', InputAutofocusController)
application.register('keyboard-shortcuts-search', KeyboardShortcutsSearchController)
application.register('item-select-all', ItemSelectAllController)
application.register('item-selector', ItemSelectorController)
application.register('loading-button', LoadingButtonController)
application.register('manual-frame', ManualFrameController)
application.register('map-dark-mode', MapDarkModeController)
application.register('media-library-attach', MediaLibraryAttachController)
application.register('media-library', MediaLibraryController)
application.register('menu', MenuController)
application.register('modal', ModalController)
application.register('modal-size', ModalSizeController)
application.register('persistent-modal', PersistentModalController)
application.register('multiple-select-filter', MultipleSelectFilterController)
application.register('avo-nested-form', NestedFormController)
application.register('panel-refresh', PanelRefreshController)
application.register('per-page', PerPageController)
application.register('preview', PreviewController)
application.register('record-selector', RecordSelectorController)
application.register('resource-edit', ResourceEditController)
application.register('resource-index', ResourceIndexController)
application.register('resource-search', ResourceSearchController)
application.register('resource-show', ResourceShowController)
application.register('select-filter', SelectFilterController)
application.register('select', SelectController)
application.register('self-destroy', SelfDestroyController)
application.register('sidebar', SidebarController)
application.register('sidebar-resize', SidebarResizeController)
application.register('sign-out', SignOutController)
application.register('table-row', TableRowController)
application.register('tabs', TabsController)
application.register('tabs-overflow', TabsOverflowController)
application.register('text-filter', TextFilterController)
application.register('theme-favicon', ThemeFaviconController)
application.register('tippy', TippyController)
application.register('toggle', ToggleController)
application.register('dropdown-menu', DropdownController)
application.register('popover-menu', PopoverMenuController)
application.register('sidebar-flyout', SidebarFlyoutController)
application.register('trix-body', TrixBodyController)
application.register('unsaved-changes', UnsavedChangesController)

// Field controllers
application.register('belongs-to-field', BelongsToFieldController)
application.register('checkbox-list-field', CheckboxListFieldController)
application.register('code-field', CodeFieldController)
application.register('date-field', DateFieldController)
application.register('easy-mde', EasyMdeController)
application.register('key-value', KeyValueController)
application.register('progress-bar-field', ProgressBarFieldController)
application.register('reload-belongs-to-field', ReloadBelongsToFieldController)
application.register('resizable-editor', ResizableEditorController)
application.register('tags-field', TagsFieldController)
application.register('tiptap-field', TiptapFieldController)
application.register('trix-field', TrixFieldController)
application.register('stars-field', StarsFieldController)

// Custom controllers
